import type { HeadquartersContact, ReportDefinitionRecipientInput, ReportDefinitionSchedule, ReportLineContact } from './api';
import { ReportScheduleDraft } from './report-schedule-draft.svelte';

/**
 * Uma linha de cliente enquanto se edita: o horário e quem recebe. Nada vai para a API até salvar;
 * fechar a gaveta descarta. A linha nova nasce quinzenal, dias 1 e 16 às 8h.
 */
export class ReportLineDraft {
  private static readonly FIRST: ReportDefinitionSchedule = {
    interval: 1,
    unit: 'month',
    days: [1, 16],
    startsOn: '',
    sendTime: '08:00',
  };

  contacts = $state<ReportLineContact[]>([]);
  readonly schedule: ReportScheduleDraft;

  constructor(initial: { schedule: ReportDefinitionSchedule | null; contacts: ReportLineContact[] }) {
    this.schedule = new ReportScheduleDraft(
      initial.schedule ?? { ...ReportLineDraft.FIRST, startsOn: new Date().toLocaleDateString('sv-SE') },
    );
    this.contacts = [...initial.contacts];
  }

  get hasContacts(): boolean {
    return this.contacts.length > 0;
  }

  get isComplete(): boolean {
    return this.hasContacts && this.schedule.isComplete;
  }

  isListed(contact: HeadquartersContact): boolean {
    return this.contacts.some((listed) => listed.hqCustomerId === contact.id);
  }

  add(contact: HeadquartersContact): void {
    if (this.isListed(contact)) return;
    this.contacts = [...this.contacts, { hqCustomerId: contact.id, contact }];
  }

  remove(hqCustomerId: string): void {
    this.contacts = this.contacts.filter((listed) => listed.hqCustomerId !== hqCustomerId);
  }

  toRecipients(): ReportDefinitionRecipientInput[] {
    return this.contacts.map(({ hqCustomerId }) => ({ hqCustomerId }));
  }
}
